// src/features/auth/services/authServices.js
const BASE = (process.env.REACT_APP_BACKEND_URL || "http://localhost/iphoneShop-backend").replace(/\/$/, "");
const meUrl = `${BASE}/auth/me.php`;

/* ================== Storage: token & "me" ================== */
export function setToken(token) { try { localStorage.setItem("token", token || ""); } catch {} }
export function getToken() { try { return localStorage.getItem("token") || ""; } catch { return ""; } }
export function clearToken() { try { localStorage.removeItem("token"); } catch {} }

export function setCachedMe(me) { try { localStorage.setItem("me", JSON.stringify(me || null)); } catch {} }
export function getCachedMe() {
  try { const raw = localStorage.getItem("me"); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
export function clearCachedMe() { try { localStorage.removeItem("me"); } catch {} }

/* Alias para compatibilidad con código viejo que aún importe estos nombres */
export const writeCachedUser = setCachedMe;
export function clearAuthStorage() { clearToken(); clearCachedMe(); }

/* ================== Permisos helpers ================== */
const isLocalLike = () =>
  process.env.NODE_ENV !== "production" &&
  /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname || "");

export const hasAllPerms = (user, required = []) => {
  if (!user) return false;
  if (isLocalLike() && user.rol === "implementer") return true;
  if (user.perms?.includes("*")) return true;
  return Array.isArray(required) && required.every((p) => user.perms?.includes(p));
};
export const hasAnyPerm = (user, list = []) =>
  !!user && (user.perms?.includes("*") || list.some((p) => user.perms?.includes(p)));
export const isOwner = (user) => user?.rol === "owner" || user?.perms?.includes("*");

/* ================== Anti-rebote post-login ================== */
export function markJustLoggedIn() {
  try { sessionStorage.setItem("justLoggedInAt", String(Date.now())); } catch {}
}
export function wasJustLoggedIn(windowMs = 2000) {
  try {
    const t = Number(sessionStorage.getItem("justLoggedInAt") || "0");
    return t && (Date.now() - t) < windowMs;
  } catch { return false; }
}

/* ================== Util: headers auth ================== */
export function getAuthHeaders() {
  const token = getToken();
  const h = { Accept: "application/json" };
  if (token) {
    h.Authorization = `Bearer ${token}`;
    h["X-Auth-Token"] = token; // plan B por si algún proxy no pasa Authorization
  }
  return h;
}

/* ================== Obtener usuario/me ================== */
export async function obtenerUsuario({ useCacheFirst = true } = {}) {
  if (useCacheFirst) {
    const cached = getCachedMe();
    if (cached && (cached.nombre || cached.correo)) return cached;
  }

  // 1) Intento normal con cookie + Bearer
  try {
    const resp = await fetch(meUrl, {
      method: "GET",
      credentials: "include",
      headers: getAuthHeaders(),
      cache: "no-store",
    });
    if (!resp.ok) throw new Error("HTTP " + resp.status);
    const data = await resp.json();
    const me = (data && typeof data === "object") ? (data.usuario ?? data) : null;
    if (me && (me.nombre || me.correo)) { setCachedMe(me); return me; }
  } catch (_) {
    // seguimos al intento 2
  }

  // 2) Último recurso: pasar token por query (por si algún proxy bloquea headers)
  try {
    const t = getToken();
    if (!t) return null;
    const resp2 = await fetch(`${meUrl}?access_token=${encodeURIComponent(t)}`, {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!resp2.ok) throw new Error("HTTP " + resp2.status);
    const data2 = await resp2.json();
    const me2 = (data2 && typeof data2 === "object") ? (data2.usuario ?? data2) : null;
    if (me2 && (me2.nombre || me2.correo)) { setCachedMe(me2); return me2; }
  } catch {}

  return null;
}

export { meUrl, BASE };
